<template>
  <Card tag="form" class="project-mutate-devtools" @submit.prevent="$emit('submit')" :title="$t('devtools')">
    <template #default>
      <hr />
      <Paywall
        :value="[true]"
        :items="[true]"
        :options="{ units, theme: 'border' }"
        :action="addon => $store.dispatch('Project/addon', { addon, state: true })"
      >
        <InputComponent label="Custom CSS" class="mt-2">
          <PrismEditor v-model="value.inject.css" language="css" line-numbers />
        </InputComponent>
        <InputComponent label="Custom JS" class="mt-2">
          <PrismEditor v-model="value.inject.js" language="js" line-numbers />
        </InputComponent>
        <CustomFields
          v-model="value.customFields"
          :schema="customFieldSchemas"
          :data="data"
          :placement="['devtools', 'project:devtools']"
          :validator="validator"
          validator-prefix="customFields"
          :disabledFields="$path('metadata.disabledFields.project', item)"
        />
      </Paywall>
    </template>
  </Card>
</template>

<script>
import { mapState } from 'vuex'
import { i18n } from '@/i18n'
import Store from '@/store'

import Card from '@/components/Card'
import { InputComponent } from 'vue-elder-input'
import PrismEditor from '@/components/PrismEditor'
import CustomFields from '@kvass/custom-fields'
import { Paywall } from '@/components/Upsell'

const meta = {
  order: 1008,
  skip: !Store.getters.isDeveloper,
  id: 'devtools',
  label: i18n.t('devtools'),
  icon: ['fal', 'code'],
}

export { meta }
export default {
  props: {
    value: Object,
    data: Object,
    labels: Object,
    validator: Object,
    customFieldSchemas: { type: Array, default: () => [] },
  },
  computed: {
    ...mapState('Project', {
      item(state) {
        return state.item && Object.keys(state.item).length ? state.item : this.data
      },
    }),
    ...mapState(['enums']),
    addons(state) {
      return this.$path('item.metadata.addons', state) || []
    },
    units(state) {
      return this.$path('item.metadata.limits.units', state)
    },
  },
  components: {
    Card,
    InputComponent,
    CustomFields,
    PrismEditor,
    Paywall,
  },
}
</script>

<style lang="scss">
.project-mutate-devtools {
}
</style>
